module.exports = __webpack_public_path__ + "static/media/portfolio-12.60c37114.jpg";